/**
 * Created by mh on 2017/5/24.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { withRouter, NavLink } from 'react-router-dom';

@withRouter
@inject('auth')
@observer
class MainNavigation extends Component {
    render() {
        const { auth } = this.props;
        return (
            <ul className="navbar-nav mr-auto">
                {auth.isLoggedIn ? (
                    <li className="nav-item">
                        <NavLink className="nav-link" activeClassName="active" to="/home/">
                            <FormattedMessage id="TopMenu.Home" defaultMessage="Home" />
                        </NavLink>
                    </li>
                ) : null}
                {/* <li className="nav-item">
                        <NavLink
                            className="nav-link"
                            activeClassName="active"
                            to="/ingest/">
                            <FormattedMessage id="TopMenu.Ingest" defaultMessage="Ingest" />
                        </NavLink>
                    </li> */}
                {auth.isLoggedIn ? (
                    <li className="nav-item">
                        <NavLink className="nav-link" activeClassName="active" to="/assets/">
                            <FormattedMessage id="TopMenu.Assets" defaultMessage="Assets" />
                        </NavLink>
                    </li>
                ) : null}
                {auth.isLoggedIn ? (
                    <li className="nav-item">
                        <NavLink className="nav-link" activeClassName="active" to="/channels/">
                            <FormattedMessage id="TopMenu.Channels" defaultMessage="Channels" />
                        </NavLink>
                    </li>
                ) : null}
                <li className="nav-item">
                    <NavLink className="nav-link" activeClassName="active" to="/help">
                        <FormattedMessage id="TopMenu.Help" defaultMessage="Help" />
                    </NavLink>
                </li>
                {/* <li className="nav-item">
                        <NavLink
                            className="nav-link"
                            activeClassName="active"
                            to="/admin/">
                            <FormattedMessage id="TopMenu.Admin" defaultMessage="Admin" />
                        </NavLink>
                    </li> */}
                {/* <li className="nav-item">
                        <NavLink
                            className="nav-link"
                            activeClassName="active"
                            to="/login/">
                            <FormattedMessage id="TopMenu.Help" defaultMessage="Help" />
                        </NavLink>
                    </li> */}
            </ul>
        );

        // As a placeholder
    }
}

MainNavigation.wrappedComponent.propTypes = {
    auth: PropTypes.object.isRequired,
};
// MainNavigation.defaultProps = {
//     auth: null,
// };

export default injectIntl(MainNavigation);
